import { render, staticRenderFns } from "./form-video.vue?vue&type=template&id=0a77067a"
import script from "./form-video.vue?vue&type=script&lang=js"
export * from "./form-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports